import { Routes } from '@angular/router';
import { AuthGuard, LoginSuccessGuard } from '@uoa/auth';
import { NzseisAdminGuard } from './app/core/guards/nzseis-admin.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [LoginSuccessGuard],
    loadComponent: () => import('./app/pages/home/home.page').then((m) => m.HomePage),
    pathMatch: 'full',
  },
  {
    path: 'error/:errorCode',
    loadChildren: () => import('./app/error-routing/error.routes').then((m) => m.errorRoutes),
  },
  {
    path: 'home',
    canActivate: [LoginSuccessGuard],
    loadComponent: () => import('./app/pages/home/home.page').then((m) => m.HomePage),
  },

  // Public
  {
    path: 'map',
    loadComponent: () => import('./app/pages/map/map.page').then((m) => m.MapPage),
  },
  {
    path: 'stations',
    loadComponent: () => import('./app/pages/stations/stations.page').then((m) => m.StationsPage),
  },
  {
    path: 'stations/:code',
    loadComponent: () =>
      import('./app/pages/station-detail/station-detail.page').then((m) => m.StationDetailPage),
  },
  {
    path: 'about',
    loadComponent: () => import('./app/pages/about/about.page').then((m) => m.AboutPage),
  },
  {
    path: 'acknowledgements',
    loadComponent: () => import('./app/pages/acknowledgements/acknowledgements.page').then((m) => m.AcknowledgementsPage),
  },

  // Admin — must be authenticated (AuthGuard) AND in Nzseis_users group (NzseisAdminGuard)
  {
    path: 'admin',
    canActivate: [AuthGuard, NzseisAdminGuard],
    loadChildren: () => import('./app/pages/admin/admin.routes').then((m) => m.adminRoutes),
  },

  { path: '**', redirectTo: '/map' },
];
